import commonPageService from 'mCommon/services/commonPageService';
import video from 'globalCommon/utils/video';
import { syncRender } from 'globalCommon/services/syncRender';
import './style.css';

function init() {
    commonPageService({ renderAfter: syncRender });
    video.init();
}

init();
